import LoginEvent, { AlreadyLogin, LoginSuccess, Logout, NeedLogin } from '@/events/login-event';
import { currentUser } from '@/services';

let timer: number | undefined;
const createHeartbeat = () => {
  if (timer) {
    clearTimeout(timer);
    timer = undefined;
  }

  setTimeout(() => {
    createHeartbeat();
  }, 300000);

  currentUser().subscribe();
};

const closeService = () => {
  if (timer) {
    clearTimeout(timer);
    timer = undefined;
  }
};

LoginEvent.on(NeedLogin, () => {
  closeService();
});
LoginEvent.once(AlreadyLogin, () => {
  createHeartbeat();
});
LoginEvent.on(LoginSuccess, () => {
  createHeartbeat();
});
LoginEvent.on(Logout, () => {
  closeService();
});
